import Vue from 'vue';

const ModalBus = new Vue();

export default {
	install(Vue) {
		Vue.prototype.$modalBus = ModalBus;
		Vue.prototype.$alert = function (message) {
			ModalBus.$emit('ALERT', message);
		};
		Vue.prototype.$verify = function (message, response) {
			ModalBus.$emit('VERIFY', { message: message, response: response });
		};
		Vue.prototype.$verifyShortForm = function (message, response) {
			ModalBus.$emit('VERIFYSHORT', { message: message, response: response });
		};
		Vue.prototype.$verifyShortFormExisting = function (message, response) {
			ModalBus.$emit('VERIFYSHORTEXISTING', { message: message, response: response });
		};
		Vue.prototype.$prompt = function (message, initial, response) {
			ModalBus.$emit('PROMPT', { message: message, initial: initial, response: response });
		};
		Vue.prototype.$notify = function (message) {
			ModalBus.$emit('NOTIFY', message);
		};
	},
};
